import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/i18n/translations";
import HomePage from "@/pages/HomePage";
import SolutionsPage from "@/pages/SolutionsPage";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";
import PosPage from "@/pages/PosPage";
import TerminalDetailPage from "@/pages/TerminalDetailPage";
import PartnersPage from "@/pages/PartnersPage";
import FeaturesPage from "@/pages/FeaturesPage";
import OnlinePaymentsPage from "@/pages/OnlinePaymentsPage";
import PayByLinkPage from "@/pages/PayByLinkPage";
import TerminalsInfoPage from "@/pages/TerminalsInfoPage";
import TermsPage from "@/pages/TermsPage";
import LegalPage from "@/pages/LegalPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import LocalPage from "@/pages/LocalPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Analytics from "@/components/Analytics";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Analytics />
          <Toaster position="top-right" />
        <Routes>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/" element={<LayoutWrapper><HomePage /></LayoutWrapper>} />
          <Route path="/solutions" element={<LayoutWrapper><SolutionsPage /></LayoutWrapper>} />
          <Route path="/terminaux/:slug" element={<LayoutWrapper><TerminalDetailPage /></LayoutWrapper>} />
          <Route path="/tarifs" element={<LayoutWrapper><PricingPage /></LayoutWrapper>} />
          <Route path="/contact" element={<LayoutWrapper><ContactPage /></LayoutWrapper>} />
          <Route path="/pos" element={<LayoutWrapper><PosPage /></LayoutWrapper>} />
          <Route path="/partenaires" element={<LayoutWrapper><PartnersPage /></LayoutWrapper>} />
          <Route path="/fonctionnalites" element={<LayoutWrapper><FeaturesPage /></LayoutWrapper>} />
          <Route path="/paiement-en-ligne" element={<LayoutWrapper><OnlinePaymentsPage /></LayoutWrapper>} />
          <Route path="/liens-de-paiement" element={<LayoutWrapper><PayByLinkPage /></LayoutWrapper>} />
          <Route path="/terminaux-de-paiement" element={<LayoutWrapper><TerminalsInfoPage /></LayoutWrapper>} />
          <Route path="/conditions-generales" element={<LayoutWrapper><TermsPage /></LayoutWrapper>} />
          <Route path="/conformite" element={<LayoutWrapper><LegalPage /></LayoutWrapper>} />
          <Route path="/a-propos" element={<LayoutWrapper><AboutPage /></LayoutWrapper>} />
          <Route path="/faq" element={<LayoutWrapper><FAQPage /></LayoutWrapper>} />
          <Route path="/terminal-paiement-geneve" element={<LayoutWrapper><LocalPage /></LayoutWrapper>} />
          <Route path="/terminal-paiement-lausanne" element={<LayoutWrapper><LocalPage /></LayoutWrapper>} />
          <Route path="/terminal-paiement-zurich" element={<LayoutWrapper><LocalPage /></LayoutWrapper>} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
    </HelmetProvider>
  );
}

function LayoutWrapper({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default App;
